<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px" @change="tabSelected">
      <a-tab-pane key="1" :tab="$t('tab.itemInformation')" style="margin-top: -14px">
        <TemporaryCountingTable ref="temporaryCountingTable" @dblclick="dblclick"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.detailsInformation')" forceRender style="margin-top: -14px">
        <TemporaryCountingDetail
          ref="temporaryCountingDetail"
          :containerDisabled="containerDisabled"
          :counting-type="countingType"
          :itemDisabled="itemDisabled"
          :locationDisabled="locationDisabled"
          :logicalStoreDisabled="logicalStoreDisabled"
          :lotDisabled="lotDisabled"
          :order-type="queryParam.value.business.orderType"
          :packDisabled="packDisabled"
          :quantityDisabled="quantityDisabled"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="$refs.temporaryCountingAdd.open()"/>
        <vxe-button :disabled="activeKey==='1'" content="button.save" size="mini" status="primary" @click="save"/>
      </a-space>
    </a-tabs>
    <TemporaryCountingAdd ref="temporaryCountingAdd" :order-type="queryParam.value.business.orderType"/>
  </a-layout>
</template>

<script>
import TemporaryCountingTable from '@/views/counting/temporary_counting/TemporaryCountingTable.vue'
import TemporaryCountingDetail from '@/views/counting/temporary_counting/TemporaryCountingDetail.vue'
import TemporaryCountingAdd from '@/views/counting/temporary_counting/TemporaryCountingAdd.vue'

export default {
  name: 'TemporaryCounting',
  components: { TemporaryCountingTable, TemporaryCountingDetail, TemporaryCountingAdd },
  props: {
    queryParam: { type: Object, default: null },
    countingType: { type: Number, default: 0 },
    itemDisabled: { type: Boolean, default: false },
    lotDisabled: { type: Boolean, default: false },
    packDisabled: { type: Boolean, default: false },
    locationDisabled: { type: Boolean, default: false },
    containerDisabled: { type: Boolean, default: false },
    logicalStoreDisabled: { type: Boolean, default: false },
    quantityDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      activeKey: '1'
    }
  },
  methods: {
    reset() {
      if (this.activeKey === '1') {
        this.$refs.temporaryCountingTable.reset()
      } else {
        this.$refs.temporaryCountingDetail.reset()
      }
    },
    tabSelected(key) {
      this.activeKey = key
    },
    dblclick(record) {
      this.activeKey = '2'
      this.$refs.temporaryCountingDetail.getData(record)
    },
    save() {
      this.$refs.temporaryCountingDetail.save()
    }
  }
}
</script>